function provideEncryptKey() {
    const X='utWe78';
    const Y='hber';
    const Z='yf75Yf';

    return Z + Y + X;
}

export default provideEncryptKey;